var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    on: {
      "click": _vm.onCopy
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.value))])]), _c('div', {
    staticClass: "action"
  }, [_c('cs-button'), _c('span', {
    staticClass: "action-icon"
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }